import EventRegistryCommandsWidget from './components/widget/EventRegistryCommandsWidget.vue';
import ContractVersionsWidget from './components/widget/ContractVersionsWidget.vue';
import EventsFromIntegrationWidget from './components/widget/EventsFromIntegrationWidget.vue';
import eventRegistryModule from './module/eventRegistryModule';
import EventRegistryManager from './EventRegistryManager';

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }
    options.store.registerModule('eventRegistryPlugin', eventRegistryModule);

    Vue.component('event-registry-commands-widget', EventRegistryCommandsWidget);
    Vue.component('event-registry-versions-widget', ContractVersionsWidget);
    Vue.component('event-registry-events-from-integration-widget', EventsFromIntegrationWidget);

    const eventRegistryManager = new EventRegistryManager(options.store);

    /* eslint no-param-reassign: 0 */
    Vue.prototype.$eventRegistryManager = eventRegistryManager;
    /* eslint no-param-reassign: 1 */
  },
};
